import { render, staticRenderFns } from "./leaderBoard.vue?vue&type=template&id=a3502c8a&"
import script from "./leaderBoard.vue?vue&type=script&lang=js&"
export * from "./leaderBoard.vue?vue&type=script&lang=js&"
import style0 from "./leaderBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports